import { StrategyDetailsPageInvestmentEntitiesByAdvisoryFirmQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import guid from '@/shared/utils/guid';
import { formatPercentage } from '@/shared/utils/percentage';

interface TabelBodyAdvisoryFirmProps {
  advisoryFirmTableRows: StrategyDetailsPageInvestmentEntitiesByAdvisoryFirmQuery['InvestmentEntitiesByAdvisoryFirm']['firms'];
  columns: TableColumns[];
  openAdvisorFirmDetails: (id: string) => void;
}

const TabelBodyAdvisoryFirm = ({ advisoryFirmTableRows, columns, openAdvisorFirmDetails }: TabelBodyAdvisoryFirmProps) => {
  if (!advisoryFirmTableRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {advisoryFirmTableRows.map((row) => (
        <TableRowWrapper key={guid()}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openAdvisorFirmDetails(row.tenant.id)}>
              {row.tenant.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{row.investorEntities}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.committedCapital}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.capitalCalled}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>{formatPercentage(row.percentOfCapitalCalled)}</TextCell>
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TabelBodyAdvisoryFirm;
